import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import HighlightListLayer from "../components/HighlightsListLayer";
 
 
const HighlightListPage = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Highlights  </h5><Breadcrumb title="Highlights" /></div>
 
        <HighlightListLayer />
 
 
 
    </>
  );
};
 
export default HighlightListPage;
 
 